module.exports = __webpack_public_path__ + "static/media/2_pl.e3f59660.png";